export const ACCESS_MIDDLEWARE = "ACCESS_MIDDLEWARE";
export const API_START = "API_START";
export const API_END = "API_END";
export const ACCESS_DENIED = "ACCESS_DENIED";
export const API_ERROR = "API_ERROR";

/* ROLE PERMISSION */
export const ROLE_PERMISSION_SET_PERMISSION = "ROLE_PERMISSION_SET_PERMISSION";
export const ROLE_PERMISSION_GET_PERMISSION = "ROLE_PERMISSION_GET_PERMISSION";

/* PERMISSION MIDLEWARE */
export const MIDDLEWARE_PERMISSION_ACCESS = "MIDDLEWARE_PERMISSION_ACCESS";
export const MIDDLEWARE_PERMISSION_START_API = "MIDDLEWARE_PERMISSION_START_API";
export const MIDDLEWARE_PERMISSION_END_API = "MIDDLEWARE_PERMISSION_END_API";
export const MIDDLEWARE_PERMISSION_ACCESS_DENIED = "MIDDLEWARE_PERMISSION_ACCESS_DENIED";
export const MIDDLEWARE_PERMISSION_ERROR_API = "MIDDLEWARE_PERMISSION_ERROR_API";
export const ROLE_PERMISSION_CAN = "ROLE_PERMISSION_CAN";